import React from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, Input } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Field } from "react-final-form";
import { customAlphabet } from "nanoid";
import {
  converttoPhoneFormat,
  converttoWgPhoneFormat,
} from "../../../utils/index";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "150px auto",
    alignItems: "center",
    marginTop: 15,
    marginBottom: 15,
    paddingRight: 50,
    boxSizing: "border-box",
  },
  codeContainer: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "130px auto 100px",
    alignItems: "center",
    marginTop: 15,
    marginBottom: 15,
    gridGap: 20,
    // paddingLeft: 20,
    paddingRight: 0,
    boxSizing: "border-box",
  },
  textField: {
    width: 300,
  },
  textStyle: { marginTop: 15, fontSize: 16 },
  tierTextField: { width: 145 },
  fullWidth: {
    width: "100%",
  },
}));

const TextInputRA = ({ label, source, type, value, record, ...rest }) => {
  let parse = (v) => v;
  let format = (v) => v;
  if (type === "number") {
    parse = (v) => Number(v);
    format = (v) => Number(v);
  }

  if (type === "phone") {
    format = (v) => (v ? converttoPhoneFormat(v) : null);
    parse = (v) => (v ? converttoWgPhoneFormat(v) : null);
  }

  return (
    <>
      <Field
        label={label}
        name={source}
        component={
          type === "code"
            ? RenderedCodeInput
            : type === "password"
            ? RenderedTextPassWordInput
            : RenderedTextInput
        }
        parse={parse}
        format={format}
        type={type}
        {...rest}
      />
    </>
  );
};

const RenderedTextInput = ({
  isDouble,
  placeholder,
  input,
  label,
  meta: { touched, error },
  required,
  ...custom
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {label !== "" ? (
        <Box style={{ display: "flex", flexDirection: "row" }}>
          <Typography className={classes.textStyle}>{label}</Typography>
          {required ? (
            <Typography
              className={classes.textStyle}
              style={{ color: "orange" }}
            >
              *
            </Typography>
          ) : null}
        </Box>
      ) : null}

      <TextField
        onChange={(e) => {}}
        inputProps={{ maxLength: label === "Phone" ? 10 : 200 }}
        error={!!(touched && error)}
        helperText={touched && error}
        {...input}
        {...custom}
        variant="standard"
        placeholder={placeholder}
        //variant="standard"
        className={isDouble ? classes.tierTextField : classes.textField}
        // InputProps={{
        //   disableUnderline: true,
        // }}
      />
    </Box>
  );
};

const RenderedCodeInput = ({
  placeholder,
  input,
  label,
  meta: { touched, error },
  type,
  required,
  ...custom
}) => {
  const classes = useStyles();
  const { onChange } = input;
  const handleGenerate = () => {
    const letter = customAlphabet("ABCDFEGHJKLMNPQRSTUVWXYZ", 6);
    const number = customAlphabet("1234567890", 6);
    onChange(letter() + number());
  };
  return (
    <Box className={classes.codeContainer}>
      <Box style={{ display: "flex", flexDirection: "row" }}>
        <Typography className={classes.textStyle}>{label}</Typography>
        {required ? (
          <Typography style={{ fontSize: 16, color: "orange" }}>*</Typography>
        ) : null}
      </Box>

      <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...input}
        {...custom}
        placeholder={placeholder}
        variant="standard"
        className={classes.textField}
      />

      <Button onClick={handleGenerate} variant="contained" color="primary">
        Generate
      </Button>
    </Box>
  );
};
const RenderedTextPassWordInput = ({
  isDouble,
  placeholder,
  input,
  label,
  meta: { touched, error },
  required,
  ...custom
}) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = React.useState(false);
  const { value } = input;

  return (
    <Box className={classes.container}>
      {label !== "" ? (
        <Box style={{ display: "flex", flexDirection: "row" }}>
          <Typography className={classes.textStyle}>{label}</Typography>
        </Box>
      ) : null}

      <Input
        error={!!(touched && error)}
        helperText={touched && error}
        {...custom}
        {...input}
        className={isDouble ? classes.tierTextField : classes.textField}
        id="standard-adornment-password"
        type={showPassword ? "text" : "password"}
        value={value}
        // onChange={onChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => {
                setShowPassword((prev) => {
                  return !prev;
                });
              }}
              onMouseDown={(event) => {
                event.preventDefault();
              }}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
    </Box>
  );
};

export default TextInputRA;
